export default {
  theme: (state) => {
    return state.theme;
  },

  website: (state) => {
    return state.website;
  },

  themes: (state) => {
    return state.themes;
  },
};
